/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const integrationStatusResponseSchema = z.object({
  status: z.enum([
    'CREATED',
    'QUEUED',
    'RUNNING',
    'COMPLETED',
    'COMPLETED_WITH_PENDING',
    'PARTIAL_FAILURE',
    'FAILED',
  ]),
});
